module.exports = __webpack_public_path__ + "img/mb-google-business-2.e837ce20.jpg";